class CollectionFilterDropdown {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
    }
    onInit () {
        const button = this._elem.querySelector('.filter-dropdown-button')
        const dropdown = this._elem.querySelector('.filter-dropdown__box')
        if (button) {
            button.addEventListener('click', (e) => {
                e.preventDefault()
                if (dropdown.classList.contains('filter-dropdown__box--active')) {
                    dropdown.classList.remove('filter-dropdown__box--active')
                } else {
                    dropdown.classList.add('filter-dropdown__box--active')
                }
            })
        }
    }
}
export default CollectionFilterDropdown



// WEBPACK FOOTER //
// ./resources/scripts/components/CollectionFilterDropdown.js